export function useSiteOrigin(): string {
  const configuredSiteUrl = useRuntimeConfig().public.SITE_URL;
  if (configuredSiteUrl) return configuredSiteUrl.replace(/\/+$/, "");
  return useRequestURL().origin;
}
